import { envVars } from "@/plugins/env-vars";

class Modules {
  learningDocumentsModule(): boolean {
    return envVars.getBool("VUE_APP_MODULE_LEARNING_DOCUMENTS");
  }

  bookkeepingModule(): boolean {
    return envVars.getBool("VUE_APP_MODULE_BOOKKEEPING");
  }

  integrationModule(): boolean {
    return envVars.getBool("VUE_APP_MODULE_INTEGRATIONS");
  }

  learningControlModule(): boolean {
    return envVars.getBool("VUE_APP_MODULE_LEARNING_CONTROL");
  }

  webinarRoomModule(): boolean {
    return envVars.getBool("VUE_APP_MODULE_WEBINAR_ROOM_BBB");
  }

  isAllowEditDates(): boolean {
    return envVars.getBool("VUE_APP_MODULE_IS_ALLOW_EDIT_DATES");
  }

  isHideListenersModule(): boolean {
    return envVars.getBool("VUE_APP_MODULE_HIDE_LISTENERS");
  }

  scormModuleEnabled(): boolean {
    return envVars.getBool("VUE_APP_MODULE_SCORM");
  }

  quickDocumentCreation(): boolean {
    return envVars.getBool("VUE_APP_MODULE_QUICK_DOCUMENT_CREATION");
  }

  informationModuleEnabled(): boolean {
    return envVars.getBool("VUE_APP_MODULE_SVEDEN");
  }
  learningGroupModule(): boolean {
    return envVars.getBool("VUE_APP_MODULE_LEARNING_GROUP");
  }
  studentsLimitModule(): boolean {
    return envVars.getBool("VUE_APP_MODULE_STUDENTS_LIMIT");
  }

  agentsModule(): boolean {
    return envVars.getBool("VUE_APP_MODULE_AGENTS");
  }

  laborExportModuleEnabled(): boolean {
    return envVars.getBool("VUE_APP_LABOR_EXPORT");
  }

  consentModuleEnabled(): boolean {
    return envVars.getBool("VUE_APP_CONSENT");
  }

  isSwitchFrontVersionEnabled(): boolean {
    return envVars.getBool("VUE_APP_SWITCH_FRONT_VERSION");
  }

  isStudentDocumentEnabled(): boolean {
    return envVars.getBool("VUE_APP_STUDENT_DOCUMENT");
  }
}

export const modules = new Modules();

export function learningDocumentsModule() {
  return modules.learningDocumentsModule();
}

export function quickDocumentCreationModule() {
  return modules.quickDocumentCreation();
}

export function bookkeepingModule() {
  return modules.bookkeepingModule();
}

export function integrationModule() {
  return modules.integrationModule();
}

export function learningControlModule() {
  return modules.learningControlModule();
}

export function webinarRoomModule() {
  return modules.webinarRoomModule();
}

export function isAllowEditDates() {
  return modules.isAllowEditDates();
}

export function scormModule() {
  return modules.scormModuleEnabled();
}

export function informationModule() {
  return modules.informationModuleEnabled();
}

export function hideListeners() {
  return modules.isHideListenersModule();
}
export function learningGroupModule() {
  return modules.learningGroupModule();
}

export function studentLimitModule() {
  return modules.studentsLimitModule();
}

export function agentsModule() {
  return modules.agentsModule();
}

export function laborExportModule() {
  return modules.laborExportModuleEnabled();
}

export function consentModule() {
  return modules.consentModuleEnabled();
}

export function switchFrontVersionModule() {
  return modules.isSwitchFrontVersionEnabled();
}

export function studentDocumentModule() {
  return modules.isStudentDocumentEnabled();
}
